import { render, staticRenderFns } from "./Emite.vue?vue&type=template&id=4390dafc&scoped=true"
import script from "./Emite.vue?vue&type=script&lang=js"
export * from "./Emite.vue?vue&type=script&lang=js"
import style0 from "./Emite.vue?vue&type=style&index=0&id=4390dafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4390dafc",
  null
  
)

export default component.exports